export default __webpack_public_path__ + "static/office-36b822012e65aa258e7196026bf658ff.jpg";